import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=b5488942&"
import script from "./Camera.vue?vue&type=script&lang=js&"
export * from "./Camera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/marcosalazar/Documents/HM/Timelapse/timelapse-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5488942')) {
      api.createRecord('b5488942', component.options)
    } else {
      api.reload('b5488942', component.options)
    }
    module.hot.accept("./Camera.vue?vue&type=template&id=b5488942&", function () {
      api.rerender('b5488942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Camera.vue"
export default component.exports